import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ReimburtInfoFeeApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'reimburtInfoFee'
  }

}